import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaArrowLeft, FaBriefcaseMedical, FaCheckCircle } from 'react-icons/fa';
import api from '../services/api';
import { useApp } from '../context/AppContext';

const PRIMARY = '#E8500A';
const SECONDARY = '#FF6B2C';
const DARK = '#1a1a2e';
const MUTED = '#8888a8';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const { showToast } = useApp();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      showToast(err.response?.data?.message || 'Something went wrong', 'error');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5',
      padding: '20px',
      fontFamily: "'Segoe UI', sans-serif"
    }}>
      <div style={{
        maxWidth: '450px',
        width: '100%',
        background: 'white',
        borderRadius: '24px',
        padding: '48px 40px',
        boxShadow: '0 24px 80px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 30 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: `linear-gradient(135deg,${PRIMARY},${SECONDARY})`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(232,80,10,0.32)',
          }}>
            <FaBriefcaseMedical size={18} color="white" />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 800, color: DARK, lineHeight: 1.2 }}>DocApps</div>
            <div style={{ fontSize: 10, color: MUTED, lineHeight: 1.2 }}>Solutions</div>
          </div>
        </div>

        {!submitted ? (
          <>
            <h1 style={{ fontSize: 24, fontWeight: 800, color: DARK, margin: '0 0 10px' }}>Forgot Password?</h1>
            <p style={{ fontSize: 14, color: MUTED, marginBottom: 30 }}>Enter your email address and we'll send you a link to reset your password.</p>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <div style={{ position: 'relative' }}>
                <span style={{
                  position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
                  color: '#b8b8d0', fontSize: 14
                }}><FaEnvelope /></span>
                <input
                  required type="email"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                  style={{
                    width: '100%', padding: '12px 14px 12px 42px', border: '1.5px solid #e8e8f0',
                    borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box'
                  }}
                />
              </div>

              <button
                type="submit" disabled={loading}
                style={{
                  padding: '14px 0', background: loading ? '#ccc' : `linear-gradient(135deg,${PRIMARY},${SECONDARY})`,
                  color: 'white', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700,
                  cursor: loading ? 'not-allowed' : 'pointer', boxShadow: '0 4px 18px rgba(232,80,10,0.35)'
                }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <FaCheckCircle size={50} color="#28a745" style={{ marginBottom: 20 }} />
            <h2 style={{ fontSize: 22, fontWeight: 800, color: DARK, margin: '0 0 10px' }}>Check Your Email</h2>
            <p style={{ fontSize: 14, color: MUTED, marginBottom: 30 }}>We've sent a password reset link to <strong>{email}</strong>.</p>
          </div>
        )}

        <div style={{ marginTop: 30, textAlign: 'center' }}>
          <Link to="/login" style={{
            display: 'inline-flex', alignItems: 'center', gap: 8, color: PRIMARY,
            fontSize: 14, fontWeight: 700, textDecoration: 'none'
          }}>
            <FaArrowLeft size={12} /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
